import { Box, Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import React, { useState } from "react";
import CustomTypography from "../../../../components/common/CustomTypography";
import { useProgramSetupPage } from "../../../../hooks/useProgramSetupPage";

interface SelectOption {
  id: number;
  label: string;
}

export default function Motivation_PS_5() {
  const [, setIsAnimating] = useState(false); // 애니메이션 상태 추가

  const pageKey = "motivation_5"; // 페이지를 구분할 키 값
  const { singleSelectionId, updateSingleSelection, handleNext } =
    useProgramSetupPage({
      pageKey,
      nextPageRoute: "/program-setup-2/motivation/6",
    });

  const selectOptionList: SelectOption[] = [
    { id: 1, label: "잘 해낼 수 있다" },
    { id: 2, label: "해볼만 한 것 같다" },
    { id: 3, label: "아직 걱정이 많다" },
  ];

  // 버튼 선택 로직
  const handleOptionChange = (optionId: number) => {
    updateSingleSelection(optionId);

    setTimeout(() => {
      setIsAnimating(false);
      handleNext({ singleSelectionId: optionId });
    }, 300);
  };

  return (
    <Stack spacing={5} sx={{ height: "100%" }}>
      <CustomTypography
        variant="Subtitle"
        fontWeight={500}
        sx={{
          color: theme.vars.palette.Content.Strong,
        }}
      >
        {"프로그램에 대한 나의 마음은 어떠한가요?"}
      </CustomTypography>
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <Stack
          direction={"column"}
          sx={{
            width: "100%",
            whiteSpace: "nowrap",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {selectOptionList.map(({ id, label }, optionIndex) => (
            <Stack key={`select_option_${id}`} sx={{ flexGrow: 1, gap: 1 }}>
              <Button
                fullWidth
                variant={"SingleSlim"}
                size={"lg"}
                color={singleSelectionId === id ? "primary" : "secondary"}
                sx={{
                  transition: "background-color 0.3s ease", // ease 애니메이션 추가
                }}
                onClick={() => {
                  handleOptionChange(id);
                }}
              >
                {label}
              </Button>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
